export enum StatisticType {
    NONE = "NONE",
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    WARNING = "WARNING",
}